import { render } from "./Empty.vue?vue&type=template&id=2f5b2eaf"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Empty.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2f5b2eaf"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2f5b2eaf', __exports__)) {
    api.reload('2f5b2eaf', __exports__)
  }
  
  module.hot.accept("./Empty.vue?vue&type=template&id=2f5b2eaf", () => {
    api.rerender('2f5b2eaf', render)
  })

}


export default __exports__